import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';

// Both `static` and `repeat` are stored as a 1-element array of
// `{ "<day>": { <DELIVERY_KEY>: amount } }`. Apply the delivery dict to the
// inner record so EMERALD/RUBY/STAGE_TICKET become e/r/st on the wire.
export const AttendanceRewardSchema = defineSchema({
  name: 'serverAttendanceRewards',
  fields: [
    [
      'static',
      { kind: 'array', of: { kind: 'record', value: { kind: 'dict', dict: 'delivery' } } },
    ],
    [
      'repeat',
      { kind: 'array', of: { kind: 'record', value: { kind: 'dict', dict: 'delivery' } } },
    ],
  ],
});

export interface RawAttendanceRewardRow {
  static: unknown;
  repeat: unknown;
}

export function attendanceRewardFromRaw(row: RawAttendanceRewardRow) {
  return { static: row.static, repeat: row.repeat };
}

registerCategorySchema('serverAttendanceRewards', AttendanceRewardSchema);
